// extracted by mini-css-extract-plugin
export default {"container":"styles_container__zaCB0","title":"styles_title__4z2mb","crown":"styles_crown__6yZn6","resource":"styles_resource__kptvl"};